export const ASSOCIATE = 'associate';
const associate = () => ({ type: ASSOCIATE });
export default associate;
